import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.div`
  ${typographyV2.titleMd};
`;

export const Table = styled.div`
  border-bottom: 1px solid var(--border-soft);
  border-left: none;
  border-right: none;
`;

export const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 4fr 1fr;
  gap: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--border-default);
`;

export const HeaderCell = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 2fr 4fr 1fr;
  gap: 12px;
  padding: 16px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--border-soft);
  }
`;

export const CountryCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 12px;
`;

export const IconWrapper = styled.div`
  ${borderRadius.r4}
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--surface-soft);
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Name = styled.span`
  ${typographyV2.titleBase};
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const BottomRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Subtitle = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const Description = styled.div`
  ${typographyV2.bodyBase};
`;

export const ImpactCell = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
`;
